export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-BHCNJL4XF0";

const TRACKED_PATHNAME = "/mobile/stop/17";

const isBrowser = () => typeof window !== "undefined" && typeof document !== "undefined";

export const shouldTrackAnalytics = (pathname = window?.location?.pathname) =>
  pathname === TRACKED_PATHNAME;

const ensureGtag = () => {
  if (!isBrowser() || !GA_MEASUREMENT_ID || !shouldTrackAnalytics()) {
    return null;
  }

  window.dataLayer = window.dataLayer || [];

  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  return window.gtag;
};

export const trackPageView = () => {
  if (!isBrowser() || !window.gtag || !GA_MEASUREMENT_ID || !shouldTrackAnalytics()) {
    return;
  }

  window.gtag("event", "page_view", {
    page_path: `${window.location.pathname}${window.location.search}`,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const initGA = () => {
  const gtag = ensureGtag();

  if (!gtag) {
    return;
  }

  const existingScript = document.querySelector(
    `script[src="https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`
  );

  if (!existingScript) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  if (window.__routeeyeGaInitialized) {
    return;
  }

  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
  });

  window.__routeeyeGaInitialized = true;
};
